import PopupForm from "@/components/PopupForm/PopupForm";
import YoutubeVidioPopup from "@/components/YoutubeVidioPopup/YoutubeVidioPopup";
import dynamic from "next/dynamic";
import { useState } from "react";

import ProgramBlog from "@/components/ProgramBlog/ProgramBlog";
import ReadMoreDropDown from "@/components/ReadMore/ReadMore";
import InfoSection from "@/components/InfoSection/InfoSection";
import StickyFooter from "@/components/StickyFooter/StickyFooter";

const AdmissionProcess = dynamic(
  () => import("@/components/AdmissionProcess/AdmissionProcess")
);
const CareerPath = dynamic(() => import("@/components/CareerPath/CareerPath"));
const CoreModules = dynamic(
  () => import("@/components/CoreModules/CoreModules")
);
const Layout = dynamic(() => import("@/components/Layout/Layout"));
const ProgramBanner = dynamic(
  () => import("@/components/ProgramBanner/ProgramBanner")
);
const ProgramNav = dynamic(() => import("@/components/ProgramNav/ProgramNav"));
const ProgramOverview = dynamic(
  () => import("@/components/ProgramOverview/ProgramOverview")
);
const ProgramStickyForm = dynamic(
  () => import("@/components/ProgramStickyForm/ProgramStickyForm")
);
const SchoolFaq = dynamic(() => import("@/components/SchoolFaq/SchoolFaq"));
const StudentFunding = dynamic(
  () => import("@/components/StudentFunding/StudentFunding")
);
const Testimonials = dynamic(
  () => import("@/components/Testimonials/Testimonials")
);

const ProgramPage = ({ cmsData, commonData }: any) => {
  const [BroutcherLink, setBroutcherLink] = useState("");
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isYoutubePopup, setIsisYoutubePopup] = useState(false);
  const [youtubeVideoLink, setYoutubeVideoLink] = useState("");

  const handleBroutcherButtonClick = (broutcherLink?: any) => {
    setIsPopupVisible(true);
    setBroutcherLink(broutcherLink);
  };

  const handlePopupClose = () => {
    setIsPopupVisible(false);
    setBroutcherLink("");
  };

  const YoutubePopupButtonClick = (videoLink: string) => {
    setIsisYoutubePopup(true);
    setYoutubeVideoLink(videoLink);
  };

  const handleYoutubePopupClose = () => {
    setIsisYoutubePopup(false);
  };
  const StickyFooterComponent = cmsData?.sticky_footer?.is_sticky_footer_enabled
    ? cmsData?.sticky_footer
    : commonData?.sticky_footer?.is_sticky_footer_enabled
    ? commonData?.sticky_footer
    : null;
  const StudentFundingData = cmsData?.sections?.financial_aid?.student_funding
    ? cmsData?.sections?.financial_aid?.student_funding
    : commonData?.program_student_funding_section;

  return (
    <Layout
      SeoData={cmsData?.seo_data}
      commonData={commonData}
      schemaFaq={cmsData?.frequently_asked_questions?.questions}
      CourseData={cmsData?.program_brochure?.list_items}
    >
      {isPopupVisible && (
        <PopupForm
          isVisible={isPopupVisible}
          onClose={handlePopupClose}
          BroutcherLink={BroutcherLink}
          programOfIntrest={cmsData.program_name}
        />
      )}
      {isYoutubePopup && (
        <YoutubeVidioPopup
          isVisibleVideo={isYoutubePopup}
          youtubeVideoLink={youtubeVideoLink}
          onClose={handleYoutubePopupClose}
        />
      )}
      <div>
        <div className="pageContainer">
          {cmsData?.program_banner && (
            <ProgramBanner Data={cmsData?.program_banner} />
          )}
          <div className="container">
            <div className="contentContainer">
              <div className="leftSection">
                <div>
                  <ProgramNav />
                  <section id="overview">
                    {cmsData?.sections?.overiew_section && (
                      <ProgramOverview
                        data={cmsData?.sections?.overiew_section}
                      />
                    )}
                  </section>
                  <section id="core-modules">
                    {cmsData?.sections?.core_modules && (
                      <CoreModules data={cmsData?.sections?.core_modules} />
                    )}
                  </section>
                  <section id="admission-process">
                    {cmsData?.sections?.admission_process && (
                      <AdmissionProcess
                        data={cmsData?.sections?.admission_process}
                      />
                    )}
                  </section>
                  {/* <section id="financial-aid"> */}
                  {cmsData?.sections?.financial_aid && (
                    <CareerPath data={cmsData?.sections?.financial_aid} />
                  )}
                  {/* </section> */}
                  <section id="financial-aid">
                    {StudentFundingData && (
                      <StudentFunding
                        data={StudentFundingData}
                        programPage={true}
                      />
                    )}
                  </section>
                  <section id="testimonials">
                    <Testimonials data={cmsData?.sections?.testimonial} />
                  </section>
                  <div>
                    {cmsData?.openday_banner && (
                      <InfoSection data={cmsData?.openday_banner} />
                    )}
                  </div>
                </div>
                {cmsData?.sections?.program_blogs &&
                  cmsData.sections.program_blogs.length > 0 && (
                    <ProgramBlog Data={cmsData.sections.program_blogs} />
                  )}

                {cmsData?.frequently_asked_questions && (
                  <SchoolFaq Data={cmsData?.frequently_asked_questions} />
                )}
              </div>
              <div className="rightSection">
                <div className="FormSection">
                  {cmsData?.program_brochure && (
                    <ProgramStickyForm
                      data={cmsData?.program_brochure}
                      handleBroutcherButtonClick={handleBroutcherButtonClick}
                      handleEnrollButtonVidio={(videoLink: string) =>
                        YoutubePopupButtonClick(videoLink)
                      }
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {cmsData?.read_more_section && (
        <ReadMoreDropDown Data={cmsData?.read_more_section} />
      )}
      {StickyFooterComponent && <StickyFooter data={StickyFooterComponent} />}
    </Layout>
  );
};

export default ProgramPage;
